import * as React from "react"
import { SVGProps } from "react"

const WarranyAndReturn = (props: SVGProps<SVGSVGElement>) => (
	<svg
		{...props}
		width="300"
		height="300"
		viewBox="0 0 300 300"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M280 60.373L180 32.373L150.005 79.9154L150 79.9141L149.995 79.9154L120 32.373L20 60.373L49.9986 107.921L49.9914 107.923L49.9988 107.925L20 155.473L50 163.873V239.473L150 267.473L250 239.473V163.873L280 155.473L250.001 107.925L250.009 107.923L250.001 107.921L280 60.373Z"
			fill="white"
		/>
		<path
			d="M150 135.923V267.473L50 239.473V173.923"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M150 135.923V267.473L250 239.473V173.923"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M150 135.923L50 107.923L20 155.473L120 183.473L150 135.923Z"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M280 60.373L180 32.373L150 79.9229L250 107.923L280 60.373Z"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M150 135.923L250 107.923L280 155.473L180 183.473L150 135.923Z"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M20 60.373L120 32.373L150 79.9229L50 107.923L20 60.373Z"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M218.411 227.366V210.689"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M223.181 214.46L218.411 210.689L213.641 216.46"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M233.438 222.762V206.085"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M238.208 209.855L233.438 206.085L228.668 211.855"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M213.047 237.317L238.305 230.338"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M62.1172 230.872L74.7461 234.362"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M62.1172 218.873L74.7461 222.362"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M62.1172 206.873L87.375 213.852"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M162.074 240.362L174.703 236.873"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M162.074 252.362L187.332 245.383"
			stroke="#2A2D33"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<mask
			id="mask0_13117_573"
			mask-type="alpha"
			maskUnits="userSpaceOnUse"
			x="50"
			y="48"
			width="201"
			height="87"
		>
			<path
				d="M150 134.375L50 106.897V48.2666H150H250.004V106.827L150 134.375Z"
				fill="black"
			/>
		</mask>
		<g mask="url(#mask0_13117_573)">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M147.284 100.586C146.316 96.1502 144.453 91.0645 141.541 91.0645C138.063 91.0645 134.946 99.1291 132.085 109.619C126.45 117.516 125.348 128.522 125.681 134.443C125.689 137.375 127.828 148.003 136.311 167.053H187.982L168.377 131.712C174.477 125.579 174.164 111.137 164.181 104.219C163.455 99.4882 161.468 92.0514 157.947 92.0514C155.271 92.0514 153.732 96.3451 152.95 100.483C152.182 100.424 151.39 100.394 150.572 100.394C149.426 100.394 148.331 100.46 147.284 100.586Z"
				fill="white"
			/>
			<path
				d="M147.284 100.586L147.463 102.075C146.695 102.167 145.983 101.661 145.818 100.905L147.284 100.586ZM132.086 109.619L133.533 110.013C133.486 110.184 133.41 110.346 133.307 110.49L132.086 109.619ZM125.681 134.443L127.178 134.359C127.18 134.385 127.181 134.412 127.181 134.438L125.681 134.443ZM136.311 167.053V168.553C135.719 168.553 135.182 168.204 134.941 167.663L136.311 167.053ZM187.982 167.053L189.294 166.325C189.551 166.79 189.544 167.356 189.275 167.814C189.005 168.272 188.513 168.553 187.982 168.553V167.053ZM168.377 131.712L167.066 132.44C166.742 131.856 166.843 131.128 167.314 130.655L168.377 131.712ZM164.181 104.219L163.327 105.452C162.988 105.217 162.761 104.854 162.698 104.446L164.181 104.219ZM152.95 100.483L154.424 100.762C154.282 101.512 153.598 102.037 152.836 101.979L152.95 100.483ZM150.572 100.394L150.572 101.894L150.572 100.394ZM145.818 100.905C145.346 98.7409 144.672 96.5089 143.811 94.8544C143.38 94.0265 142.941 93.4201 142.521 93.0371C142.114 92.6664 141.796 92.5645 141.541 92.5645V89.5645C142.743 89.5645 143.75 90.0983 144.541 90.8197C145.319 91.5289 145.952 92.4712 146.472 93.469C147.512 95.4662 148.254 97.9948 148.749 100.266L145.818 100.905ZM141.541 92.5645C141.288 92.5645 140.815 92.7113 140.115 93.4906C139.429 94.2543 138.697 95.4414 137.938 97.0486C136.426 100.252 134.959 104.785 133.533 110.013L130.639 109.224C132.074 103.963 133.596 99.219 135.226 95.7674C136.038 94.0472 136.916 92.5625 137.883 91.4863C138.835 90.4257 140.056 89.5645 141.541 89.5645V92.5645ZM133.307 110.49C127.952 117.994 126.855 128.603 127.178 134.359L124.183 134.527C123.841 128.442 124.949 117.039 130.865 108.748L133.307 110.49ZM127.181 134.438C127.185 135.681 127.669 138.901 129.257 144.279C130.831 149.61 133.462 156.968 137.682 166.443L134.941 167.663C130.677 158.088 127.997 150.606 126.38 145.128C124.776 139.697 124.186 136.137 124.181 134.447L127.181 134.438ZM136.311 165.553H187.982V168.553H136.311V165.553ZM186.67 167.78L167.066 132.44L169.689 130.985L189.294 166.325L186.67 167.78ZM167.314 130.655C169.962 127.992 171.348 123.344 170.819 118.42C170.294 113.54 167.906 108.625 163.327 105.452L165.035 102.986C170.44 106.731 173.199 112.496 173.802 118.1C174.4 123.66 172.892 129.3 169.441 132.77L167.314 130.655ZM162.698 104.446C162.344 102.141 161.69 99.2329 160.729 96.9412C160.246 95.79 159.723 94.8844 159.189 94.2898C158.659 93.6997 158.248 93.5514 157.947 93.5514V90.5514C159.406 90.5514 160.565 91.3327 161.42 92.2849C162.272 93.2325 162.951 94.4817 163.495 95.7811C164.59 98.3904 165.292 101.566 165.664 103.991L162.698 104.446ZM157.947 93.5514C157.516 93.5514 156.842 93.9038 156.073 95.4008C155.353 96.8034 154.805 98.7477 154.424 100.762L151.476 100.204C151.878 98.0803 152.491 95.8089 153.404 94.0301C154.27 92.3458 155.703 90.5514 157.947 90.5514V93.5514ZM152.836 101.979C152.108 101.923 151.353 101.894 150.572 101.894L150.572 98.8943C151.427 98.8943 152.257 98.9257 153.064 98.9872L152.836 101.979ZM150.572 101.894C149.484 101.894 148.448 101.957 147.463 102.075L147.105 99.0963C148.214 98.9632 149.369 98.8943 150.572 98.8943L150.572 101.894Z"
				fill="#2A2D33"
			/>
			<path
				d="M178.394 122.121H166.831"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<path
				d="M179.282 115.724L167.934 118.038"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<path
				d="M134.69 122.121H146.253"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<path
				d="M134.715 114.724L146.063 117.038"
				stroke="#2A2D33"
				strokeWidth="3"
				strokeLinecap="round"
			/>
			<ellipse
				rx="2.26216"
				ry="3.4748"
				transform="matrix(-1 0 0 1 162.602 113.448)"
				fill="#2A2D33"
			/>
			<ellipse
				rx="2.26216"
				ry="3.4748"
				transform="matrix(-1 0 0 1 150.751 113.448)"
				fill="#2A2D33"
			/>
		</g>
	</svg>
)

export default WarranyAndReturn
